<template><svg viewBox="0 0 20 13" xmlns="http://www.w3.org/2000/svg"><path d="M6 9h2v4H6zM0 7h2v6H0zm12-7h2v13h-2zm6 5h2v8h-2z"/></svg></template>